import '../styles/admission.css'
import { handleOnlineFormClick } from '../utils/utils';

const Admissions = () => {

    return ( 
        <div className="admissions-cont">
            <div className="admission-header-image"></div>
            <div className='btn-div'>
                <button onClick={handleOnlineFormClick}>ONLINE ADMISSION FORM</button>
            </div>
            <div className="admissions-info">
                <span>Admissions at Acharya International ICSE School are conducted with a focus on selecting students who
                demonstrate academic potential, character, and a commitment to the school's values. Here's an overview of our
                admissions process:</span>

                <p><span>Application Submission:</span> Prospective students or their parents/guardians are required to complete and submit
                an application form, which can typicallybe obtained from the school's admission office or website. The application form may require information such as the student's personal details, academic history, extracurricular
                activities, and any other relevant information.</p>

                <p><span>Entrance Examination/Assessment:</span> Depending on the grade level, applicants may be required to undergo an
                entrance examination or assessment to evaluate their academic proficiency and readiness for the school's
                curriculum. The examination may cover subjects such as English, Mathematics, and General Knowledge.</p>

                <p><span>Interview:</span> Shortlisted candidates may be invited for an interview with school administrators or faculty members.
                The interview provides an opportunity for the school to assess the student's personal qualities, interests, and
                suitability for the school community.</p>

                <p><span>Submission of Documents:</span> Applicants are typically required to submit certain documents along with their
                application, which may include academic transcripts or report cards from previous schools, birth certificate,
                passport-sized photographs, and any other documents requested by the school.</p>

                <p><span>Parental Interview/Interaction: </span> In some cases, the school may also conduct interviews or interactions with
                parents or guardians to discuss the student's educational background, goals, and expectations.</p>

                <p><span>Admission Decision:</span> After completing the evaluation process, the school's admissions committee will make a
                decision regarding each applicant's admission. Successful candidates will receive an offer of admission, along
                with details regarding enrollment procedures, fees, and other relevant information.</p>

                <p><span>Enrollment:</span> Upon acceptance of the offer of admission, parents or guardians are required to complete the
                enrollment process, which typically involves submitting the necessary enrollment forms, paying the required fees,
                and providing any additional documentation as requested by the school.</p>

                <p>It's important to note that the specific admissions process and requirements may vary depending on factors such
                as the grade level, availability of seats, and the school's policies. Prospective applicants are encouraged to 
                contact the school's admission office for detailed information and guidance regarding the admissions process</p>
            </div>
        </div>
     );
}
 
export default Admissions;